{
  "es": {
    "fleetDashboard": {
      "showAll": "Ver todo",
      "empty": "Todavía no hay nada aquí.",
      "failed": "No se ha podido cargar ahora mismo.",
      "unnamed": "Sin título",
      "formats": {
        "weekday": "EEE",
        "day": "d"
      },
      "activity": {
        "title": "Últimas novedades",
        "you": "Tú",
        "kinds": {
          "member_joined": "Se unió a la flota",
          "event_published": "Evento publicado",
          "event_cancelled": "Evento cancelado",
          "contract_published": "Contrato publicado",
          "contract_claimed": "Contrato aceptado",
          "contract_fulfilled": "Contrato cumplido",
          "inventory_transfer_completed": "Transferencia completada",
          "inventory_item_deposited": "Depositado",
          "inventory_item_withdrawn": "Retirado"
        },
        "empty": {
          "title": "Todavía no ha pasado nada",
          "hint": "Aquí aparecen los eventos y contratos publicados, los más recientes primero."
        }
      },
      "events": {
        "title": "Próximos eventos",
        "signUp": "Apuntarse",
        "empty": {
          "title": "Nada planeado para las próximas dos semanas",
          "hint": "Consulta la página de eventos para ver lo que viene más adelante.",
          "hintCreate": "Pon una operación en el calendario y los miembros podrán apuntarse enseguida.",
          "action": "Planear un evento"
        }
      },
      "actionQueue": {
        "title": "Requiere tu atención",
        "joinRequests": {
          "one": "%{count} solicitud de ingreso",
          "other": "%{count} solicitudes de ingreso"
        },
        "pendingTransfers": {
          "one": "%{count} transferencia entrante por responder",
          "other": "%{count} transferencias entrantes por responder"
        },
        "partFailed": "Parte de lo que te espera no se ha podido cargar ahora mismo.",
        "empty": {
          "title": "Todo al día",
          "hint": "Aquí aparecen las solicitudes de ingreso y las transferencias entrantes que necesitan respuesta."
        }
      },
      "contracts": {
        "title": "Contratos",
        "mine": "Tu trabajo",
        "open": "Disponibles",
        "partFailed": "Algunos contratos no se han podido cargar ahora mismo.",
        "empty": {
          "title": "No hay contratos abiertos",
          "hint": "Revisa trabajos anteriores en el tablón de contratos.",
          "hintCreate": "Publica un trabajo y los miembros podrán aceptarlo.",
          "action": "Publicar un contrato"
        }
      },
      "inventory": {
        "title": "Inventario",
        "empty": "No ha habido movimientos de inventario últimamente.",
        "emptyMine": "No se ha movido nada tuyo últimamente.",
        "emptyHint": "Aquí aparecen los depósitos, las retiradas y las transferencias.",
        "mine": "Míos",
        "fleet": "Flota"
      },
      "newMembers": {
        "title": "Nuevos miembros",
        "empty": {
          "title": "Nadie nuevo últimamente",
          "hint": "Los miembros aparecen aquí en cuanto se unen."
        }
      },
      "about": {
        "title": "Sobre la flota",
        "empty": {
          "title": "Todavía no hay descripción",
          "hint": "La flota todavía no se ha presentado.",
          "hintEdit": "Cuenta a los nuevos miembros de qué va la flota.",
          "action": "Escribir una"
        }
      },
      "week": {
        "emptyDay": "Nada previsto el %{day}."
      },
      "online": {
        "title": "En línea ahora (%{count})",
        "titlePending": "En línea ahora",
        "friend": "Amigo",
        "more": {
          "one": "y %{count} más",
          "other": "y %{count} más"
        },
        "empty": {
          "title": "No hay nadie más en línea",
          "hint": "Los miembros aparecen aquí en cuanto inician sesión."
        }
      },
      "announcements": {
        "post": "Publicar un anuncio",
        "postAction": "Publicar",
        "edit": "Editar anuncio",
        "body": "Anuncio",
        "until": "hasta el %{date}",
        "confirmRemove": "¿Eliminar este anuncio para todos?",
        "expiry": {
          "label": "Mostrarlo",
          "keep": "Mantener el final actual",
          "never": "Hasta que se elimine",
          "day": "Un día",
          "days3": "Tres días",
          "week": "Una semana",
          "weeks2": "Dos semanas"
        },
        "messages": {
          "saved": "Anuncio guardado.",
          "saveFailed": "No se pudo guardar el anuncio.",
          "removed": "Anuncio eliminado.",
          "removeFailed": "No se pudo eliminar el anuncio."
        },
        "more": {
          "one": "Mostrar %{count} anuncio más",
          "other": "Mostrar %{count} anuncios más"
        }
      }
    }
  }
}
